// 9 solid mid-saturation colors with white text (Linear / Notion AI style).
// Classes are defined in src/index.css (.avatar-bg-N / .avatar-text-N) so
// Tailwind's content scanner never has to find them.
const AVATAR_COLORS = [
  { bg: "avatar-bg-0", text: "avatar-text-0" }, // sage    — hue 150
  { bg: "avatar-bg-1", text: "avatar-text-1" }, // gold    — hue 42
  { bg: "avatar-bg-2", text: "avatar-text-2" }, // coral   — hue 12
  { bg: "avatar-bg-3", text: "avatar-text-3" }, // teal    — hue 195
  { bg: "avatar-bg-4", text: "avatar-text-4" }, // violet  — hue 266
  { bg: "avatar-bg-5", text: "avatar-text-5" }, // fern    — hue 134
  { bg: "avatar-bg-6", text: "avatar-text-6" }, // wine    — hue 350
  { bg: "avatar-bg-7", text: "avatar-text-7" }, // plum    — hue 315
  { bg: "avatar-bg-8", text: "avatar-text-8" }, // rust    — hue 18
] as const

/**
 * Deterministic avatar color based on a user identifier (userId or fullName).
 * Same input always produces the same color.
 */
const DEFAULT_COLOR = AVATAR_COLORS[0]

export function getAvatarColor(identifier: string | null | undefined): { bg: string; text: string } {
  if (!identifier) return DEFAULT_COLOR
  // UUID-friendly: parse the last 8 hex chars as a 32-bit number — UUID v4's
  // tail is uniformly random, so a mod by the palette length distributes evenly.
  // Falls back to a simple char-code sum for non-hex identifiers.
  const hexOnly = identifier.replace(/[^0-9a-f]/gi, '')
  if (hexOnly.length >= 8) {
    const num = parseInt(hexOnly.slice(-8), 16)
    if (!isNaN(num)) {
      return AVATAR_COLORS[num % AVATAR_COLORS.length] ?? DEFAULT_COLOR
    }
  }
  let sum = 0
  for (let i = 0; i < identifier.length; i++) {
    sum = (sum * 31 + identifier.charCodeAt(i)) | 0
  }
  return AVATAR_COLORS[Math.abs(sum) % AVATAR_COLORS.length] ?? DEFAULT_COLOR
}

export function getInitials(fullName?: string | null | undefined): string {
  if (!fullName?.trim()) return "?"
  const parts = fullName.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
  return parts[0]?.[0]?.toUpperCase() ?? "?"
}
